<template>
  <div>
    <el-dialog
      :visible.sync="isShow"
      width="480px"
      custom-class="UpgradeDialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <div class="dialog-body">
        <div class="d-header">
          <div class="left">
            <span>动态设置</span>
          </div>
          <fm-button
            @click="handleClose"
            type="info"
            size="mini"
            text
            icon="icon-model-close"
          ></fm-button>
        </div>
        <div class="d-content">
          <div class="titless">将在「首页-动态」中将展示这些记录</div>
          <div class="d-item-box">
            <div
              v-for="(item, index) in setList"
              :key="index"
              class="d-item2"
              :class="{ active: item.type == 1 ? checkedFiles : !checkedFiles }"
              @click="chooseFile(item.type)"
            >
              <div class="d-item-flex">
                {{ item.name }}
              </div>
              <div class="d-item-right">
                <el-switch
                  :value="item.type"
                  @change="handleSwitchChange(item, $event)"
                  active-color="#F67942"
                >
                </el-switch>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="isShow2"
      width="480px"
      custom-class="UpgradeDialog2"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div class="dialog-body">
        <div class="d-header">
          <div class="left">
            <img :src="$utils.getPng('web4/icon-circle-fill')" />
            <span>提示</span>
          </div>
          <fm-button
            @click="keepOpen"
            type="info"
            size="mini"
            text
            icon="icon-model-close"
          ></fm-button>
        </div>
        <div class="d-content2">
          <div class="texts">
            关闭后该动态将会被清理，再次开启将不会有历史数据，建议保持开启
          </div>
        </div>
        <div class="d-footer">
          <fm-button type="info" plain size="small" @click="keepOpen"
            >保持开启</fm-button
          >
          <fm-button type="info" plain size="small" @click="confirmClose"
            >确认关闭</fm-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  appDynamicsSwitch,
  appDynamicsSwitchUpdate,
} from "@/utils/apiList/usermsg";
export default {
  name: "title",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    consumeInfo: {
      type: Object,
    },
  },
  watch: {
    isShow(val) {
      if (val) {
        this.checkedFiles = false;
        // 弹窗显示时获取开关状态
        this.appDynamicsSwitchFn();
      }
    },
  },
  data() {
    return {
      checkedFiles: false,
      isShow2: false,
      currentItem: null, // 当前操作的开关项
      setList: [
        { name: "开启下载文件动态", type: 1, apiKey: "download_switch" },
        { name: "开启转存文件动态", type: 2, apiKey: "transit_switch" },
        { name: "开启上传文件动态", type: 3, apiKey: "upload_switch" },
        { name: "开启收藏文件/合集动态", type: 4, apiKey: "collection_switch" },
      ],
      switchObj: {},
      originalSwitchObj: {}, // 保存原始开关状态，用于比较变化
    };
  },
  methods: {
    appDynamicsSwitchFn() {
      appDynamicsSwitch().then((res) => {
        if (res.status == 1) {
          this.switchObj = res.data;
          // 保存原始状态用于比较
          this.originalSwitchObj = JSON.parse(JSON.stringify(res.data));
          // 同步数据到setList，将字符串/数字转换为布尔值
          this.setList.forEach((item) => {
            if (res.data[item.apiKey] !== undefined) {
              // 将字符串"0"/"1"或数字0/1转换为布尔值
              item.type =
                res.data[item.apiKey] == 1;
            }
          });
        }
      });
    },
    chooseFile(type) {
      this.checkedFiles = !type;
    },
    okFn() {
      this.$emit("isok", this.checkedFiles, this.consumeInfo);
    },
    handleClose() {
      this.checkedFiles = false;
      this.$emit("handleClose");
    },
    // 处理开关变化
    handleSwitchChange(item, value) {
      // 如果是要关闭开关（从true变为false），显示确认弹窗
      if (item.type && !value) {
        // 先恢复开关状态，因为用户还没有确认
        this.$nextTick(() => {
          item.type = true;
        });
        this.currentItem = item;
        this.isShow2 = true;
      } else {
        // 直接开启开关
        this.updateSwitchStatus(item, value);
      }
    },
    // 确认关闭
    confirmClose() {
      if (this.currentItem) {
        this.updateSwitchStatus(this.currentItem, false);
        this.currentItem = null;
      }
      this.isShow2 = false;
    },
    // 保持开启
    keepOpen() {
      this.isShow2 = false;
      this.currentItem = null;
    },
    // 更新开关状态并调用接口
    updateSwitchStatus(item, newValue) {
      // 更新本地状态
      item.type = newValue;
      this.switchObj[item.apiKey] = newValue ? 1 : 0;

      // 构建需要更新的参数，只传递有变化的开关
      const updateParams = {};
      let hasChanges = false;

      this.setList.forEach((setItem) => {
        const currentValue = setItem.type ? 1 : 0;
        const originalValue = this.originalSwitchObj[setItem.apiKey];

        // 如果当前值与原始值不同，则加入更新参数
        if (currentValue !== originalValue) {
          updateParams[setItem.apiKey] = currentValue;
          hasChanges = true;
        }
      });

      // 如果有变化，调用更新接口
      if (hasChanges) {
        // 检查是否有开关被关闭（从开启变为关闭）
        const hasClosedSwitches = this.setList.some((setItem) => {
          const currentValue = setItem.type ? 1 : 0;
          const originalValue = this.originalSwitchObj[setItem.apiKey];
          // 处理字符串和数字类型的比较
          const isOriginalOn = originalValue == 1;
          const isCurrentOff = currentValue == 0;
          return isOriginalOn && isCurrentOff;
        });

        appDynamicsSwitchUpdate(updateParams)
          .then((res) => {
            if (res.status == 1) {
              // 更新成功，更新原始状态
              this.originalSwitchObj = JSON.parse(
                JSON.stringify(this.switchObj)
              );
              this.$toast(res.msg, 1);
              // 只有关闭配置时才执行SwitchObj事件
              if (hasClosedSwitches) {
                this.$emit("SwitchObj");
              }
            } else {
              // 更新失败，恢复原状态
              this.revertSwitchStatus();
              this.$toast(res.msg, 2);
            }
          })
          .catch((err) => {
            // 接口调用失败，恢复原状态
            this.revertSwitchStatus();
          });
      }
    },
    // 恢复开关状态
    revertSwitchStatus() {
      this.setList.forEach((item) => {
        const originalValue = this.originalSwitchObj[item.apiKey];
        // 将字符串"0"/"1"或数字0/1转换为布尔值
        item.type = originalValue == 1;
        this.switchObj[item.apiKey] = originalValue;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.UpgradeDialog2 {
  .title {
    margin-top: 32px;
    margin-bottom: 12px;
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    span {
      color: #f67942;
    }
  }
  .txt {
    line-height: 22px;
    margin-bottom: 24px;
    text-align: center;
  }

  .d-content2 {
    text-align: center;
    margin: 30px 0 24px 0;

    .texts {
      text-align: left;
      letter-spacing: -0.1px;
    }
  }

  .d-footer {
    display: flex;
    justify-content: flex-end;
    .btnClass {
      width: 120px;
      height: 36px;
      border-radius: 18px;
      margin-right: 20px;
      &:last-child {
        margin-left: 0px;
        margin-right: 0px;
      }
    }
  }
}

.UpgradeDialog {
  .title {
    margin-top: 32px;
    margin-bottom: 12px;
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    span {
      color: #f67942;
    }
  }
  .txt {
    line-height: 22px;
    margin-bottom: 24px;
    text-align: center;
  }

  .d-content {
    .titless {
      width: 480px;
      height: 32px;
      @include useTheme {
        background: getVar("text-color1-f9f9f9");
      }
      font-weight: 400;
      font-size: 12px;
      @include useTheme {
        color: getVar("text-color1-8a8b92");
      }
      display: flex;
      align-items: center;
      margin-left: -24px;
      margin-top: 16px;
      padding-left: 24px;
    }

    .d-item-box {
      margin-top: 4px;
      .d-item2 {
        height: 54px;
        box-shadow: inset 0px 0px 0px 0px #e5e5e5;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .d-item-flex {
          font-weight: 400;
          font-size: 14px;
          @include useTheme {
            color: getVar("text-color1-2c2c2c");
          }
          line-height: 22px;
        }

        .d-item-right {
          // 开关右侧样式，如需要可以添加具体样式
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>